module.exports = __webpack_public_path__ + "img/temp-diary.12c365bd.svg";